import React, { useEffect, useState } from 'react';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import JWPlayer from "../JWPlayer/JWPlayer";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.grey[800],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} sx={{ color: 'text.primary' }}>
            <CloseIcon sx={{ color: 'text.primary' }} />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

const DialogContent = withStyles((theme) => ({
    root: {
        padding: 0,
        minHeight: 340,
        backgroundColor: "#000",
        textAlign: 'center',
        '& .jwplayer, & .jw-wrapper, & video, & #my-unique-id': {
            margin: '0 auto !important',
            width: '100% !important',
            height: '100% !important',
            maxWidth: '100% !important',
            minHeight: '340px !important',
        },
        '& .jw-media video': {
            objectFit: 'contain !important',
        },
        [theme.breakpoints.down('sm')]: {
            minHeight: 220,
            '& .jwplayer, & .jw-wrapper, & video, & #my-unique-id': {
                minHeight: '220px !important',
            },
        }
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
    const [jwtTokenDetails, setJwtTokenDetails] = useState(props.data.jwtTokenDetails);
    const [loading, setLoading] = useState(false);
    const [videoURL, setvideoURL] = useState(props.data.videoURL);

    useEffect(() => {
        setvideoURL(props.data.videoURL);
      }, [props.data.videoURL]);

    useEffect(() => {
        setJwtTokenDetails(props.data.jwtTokenDetails);
    }, [props.data.jwtTokenDetails]);

    const handleClose = () => {
        props.onClose();
    };
    return (
        <div>
            <Dialog onClose={handleClose}
                fullWidth
                maxWidth="sm"
                aria-labelledby="customized-dialog-title"
                open={props.open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                {props.data.title}
                </DialogTitle>
                <DialogContent>
                        <Grid container direction="row" alignItems="center" justifyContent="center" style={{ width: '100%' }}>
                            <Grid item xs={12} style={{ width: '100%' }}>
                            {jwtTokenDetails && jwtTokenDetails.JWPlayerKey && jwtTokenDetails.JWPlayerSource && videoURL ? (
                                <JWPlayer jwPlayerkey={jwtTokenDetails.JWPlayerKey}
                                    jwPlayersrc={jwtTokenDetails.JWPlayerSource}
                                    fileURL={videoURL}
                                   userName={ props.data.userName}
                                   playExternalVideo={props.data.playExternalVideo}
                                />
                            ) : (
                                <Box style={{ width: '100%', minHeight: 260, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#555' }}>
                                    Loading video...
                                </Box>
                            )}
                            </Grid>
                        </Grid>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary"> Close </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}